import { config } from "./config";

export const getLocation = () => {
    (window as any)?.appInterface.getLocation();
};

export const openDatePickerDayMonthYear = (initalDate = null as null | String) => {
    // format - "YYYY-MM-dd"
    (window as any)?.appInterface.openDatePickerDayMonthYear(initalDate);
};

export const openDatePickerMonthYear = (
    initalDate = null as null | String,
    title = ""
) => {
    // format - "YYYY-MM-dd"
    (window as any)?.appInterface.openDatePickerMonthYear(initalDate, title);
};

export const getProfileImage = (
    cameraTitle?: String | null,
    galleryTitle?: String | null,
    isCancellable?: Boolean
) => {
    (window as any)?.appInterface.getProfileImage(
        cameraTitle,
        galleryTitle,
        isCancellable
    );
};

export const refreshToken = (key: string) => {
    return (window as any)?.appInterface?.refreshToken(key);
};

export const trackAnalyticsEvent = (
    eventName: String,
    propsMap: any,
    analyticsTypes: Array<String>
) => {
    // analytics options - "FIREBASE", "MIXPANEL", "CLEVERTAP", "BRANCH"
    (window as any)?.appInterface.trackAnalyticsEvent(
        eventName,
        JSON.stringify(propsMap),
        analyticsTypes
    );
};

export const setAnalyticsUserProperty = (
    propsMap: any,
    analyticsTypes: Array<String>
) => {
    // analytics options - "FIREBASE", "MIXPANEL", "CLEVERTAP", "BRANCH"
    (window as any)?.appInterface.setAnalyticsUserProperty(
        JSON.stringify(propsMap),
        analyticsTypes
    );
};

export const finishOnboarding = () => {
    (window as any)?.appInterface.finishOnBoarding();
};

export const finishWebView = () => {
    //Exposing this method in case if you want to quit the onBaording at any moment.
    //It will simply dismiss webview container/screen
    (window as any)?.appInterface.finishActivity();
};

export const showNativeLoader = () => {
    (window as any)?.appInterface.showProgressBar();
};

export const hideNativeLoader = () => {
    (window as any)?.appInterface.hideProgressBar();
};

export const setPrefsLong = (key: String, value: Number) => {
    return (window as any)?.appInterface.setPrefsLong(key, value);
};

export const getPrefsLong = (key: String) => {
    return (window as any)?.appInterface.getPrefsLong(key);
};

export const setPrefsDouble = (key: String, value: Number) => {
    return (window as any)?.appInterface.setPrefsDouble(key, value);
};

export const getPrefsDouble = (key: String) => {
    return (window as any)?.appInterface.getPrefsDouble(key);
};

export const setPrefsInt = (key: String, value: Number) => {
    return (window as any)?.appInterface.setPrefsInt(key, value);
};

export const getPrefsInt = (key: String) => {
    return (window as any)?.appInterface.getPrefsInt(key);
};

export const setPrefsString = (key: String, value: Number) => {
    return (window as any)?.appInterface.setPrefsString(key, value);
};

export const getPrefsString = (key: String) => {
    return (window as any)?.appInterface.getPrefsString(key);
};

export const setPrefsBoolean = (key: String, value: Number) => {
    return (window as any)?.appInterface.setPrefsBoolean(key, value);
};

export const getPrefsBoolean = (key: String) => {
    return (window as any)?.appInterface.getPrefsBoolean(key);
};

export const getRemoteConfigString = (key: String) => {
    return (window as any)?.appInterface.getRemoteConfigString(key);
};

export const getRemoteConfigBoolean = (key: String) => {
    return (window as any)?.appInterface.getRemoteConfigBoolean(key);
};

export const getRemoteConfigDouble = (key: String) => {
    return (window as any)?.appInterface.getRemoteConfigDouble(key);
};

export const getRemoteConfigLong = (key: String) => {
    return (window as any)?.appInterface.getRemoteConfigLong(key);
};
type UserData = {
    accessToken: string;
    id: string;
    language: string;
};
export const getUserData = () => {
    if ((window as any).appInterface.getUser) {
        const userData = (window as any)?.appInterface.getUser();
        return JSON.parse(userData) as UserData;
    }
    return {} as UserData;
};

export const getAndroidAppVersion = (): number => {
    try {
        return getPrefsInt("appVersion") || 1;
    } catch (e) {
        return 902;
    }
};

export const triggerAudioRecording = (type: "INTRO") => {
    return (window as any)?.appInterface?.triggerAudioRecording(type);
};

export const finishWebViewWithProps = (props: string): void => {
    (window as any)?.appInterface.finishWebView(props);
};
